
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/flags/[flagSlug]",
      function () {
        return require("private-next-pages/flags/[flagSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/flags/[flagSlug]"])
      });
    }
  